import { Box, IconButton, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { useProject } from "../../hooks/useProject.jsx";
import { useBackground } from "../../hooks/useBackgroundManager.jsx";

function ProjectList({ onProjectClick }) {
    const { projectsName, currentHoverProject, setCurrentHoverProject } = useProject();
    const { textColor } = useBackground();
    const isMobile = useMediaQuery('(max-width:800px)');

    return (
        <>
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: isMobile ? "center" : "left",
                justifyContent: "center",
                marginLeft: isMobile ? "0px" : "75px",
                gap: "2px",
                width: isMobile ? "100vw" : "auto"
            }}>
                <Typography
                    fontFamily={"Symtext"}
                    onClick={() => window.open("https://thefirstrun.studio/", '_blank').focus()}
                    variant="text"
                    sx={{
                        cursor: "pointer",
                        color: textColor, // Utilisation de la couleur dynamique
                        textAlign: isMobile ? "center" : "left",
                        fontSize: isMobile ? "1em" : "1.5em",
                        transition: "color 0.5s ease-in-out",
                    }}>
                    The First Run
                </Typography>
                {projectsName.map((entry, index) => (
                    <Typography
                        fontFamily={"Roboto"}
                        key={index}
                        onClick={() => onProjectClick(entry)}
                        onMouseOver={() => setCurrentHoverProject(entry)}
                        variant="text"
                        sx={{
                            cursor: "pointer",
                            color: textColor, // Utilisation de la couleur dynamique
                            textAlign: isMobile ? "center" : "left",
                            opacity: currentHoverProject === entry ? 1 : 0.8,
                            fontWeight: currentHoverProject === entry ? "bold" : "normal",
                            fontSize: isMobile ? "1em" : "1.5em",
                            transition: "color 0.5s ease-in-out",
                        }}>
                        {entry.toUpperCase()}
                    </Typography>
                ))}
            </Box>
        </>
    );
}

export default ProjectList;
